module.exports = __webpack_public_path__ + "img/80.aabb7589.jpg";